export interface AlignmentUser {
    _id: string;
    name: string | null;
    email: string;
    deptPermissions: string[];
}

export interface AlignmentInfo {
    isAligned: boolean;
    extra: string[];
    missing: string[];
}

export function computeAlignment(
    userPerms: string[],
    templatePerms: string[]
): AlignmentInfo {
    const templateSet = new Set(templatePerms);
    const userSet = new Set(userPerms);
    return {
        isAligned:
            userPerms.length === templatePerms.length &&
            userPerms.every((p) => templateSet.has(p)),
        extra: userPerms.filter((p) => !templateSet.has(p)),
        missing: templatePerms.filter((p) => !userSet.has(p)),
    };
}
